import isSSR from '@calm/web-common/dist/isSSR';
import { createContext, ReactNode, useState } from 'react';
import { ActiveCircleIdState } from './types';

export const ACTIVE_CIRCLE_KEY = 'activeCircleId';
export const DEFAULT_ACTIVE_CIRCLE_ID = -1;

export const hydrateCircleIdOrDefault = (
    defaultActiveCircleId = DEFAULT_ACTIVE_CIRCLE_ID
) =>
    isSSR()
        ? defaultActiveCircleId
        : Number.parseInt(
              sessionStorage.getItem(ACTIVE_CIRCLE_KEY) ??
                  defaultActiveCircleId.toString()
          );

export const ActiveCircleIdContext = createContext<ActiveCircleIdState>(
    undefined!
);

export function ActiveCircleIdProvider({
    defaultActiveCircleId,
    children,
}: {
    defaultActiveCircleId?: number;
    children: ReactNode | ReactNode[];
}) {
    const [activeCircleId, setActiveCircleId] = useState<number>(
        hydrateCircleIdOrDefault(defaultActiveCircleId)
    );

    return (
        <ActiveCircleIdContext.Provider
            value={{
                activeCircleId,
                hasActiveCircle: activeCircleId !== DEFAULT_ACTIVE_CIRCLE_ID,
                setActiveCircleId: (circleId: number) => {
                    if (!isSSR()) {
                        sessionStorage.setItem(
                            ACTIVE_CIRCLE_KEY,
                            circleId.toString()
                        );
                    }
                    setActiveCircleId(circleId);
                },
            }}
        >
            {children}
        </ActiveCircleIdContext.Provider>
    );
}
